import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  imgParking: string;
}


@Component({
  selector: 'app-opendialog-overview-park',
  templateUrl: './opendialog-overview-park.component.html',
  styleUrls: ['./opendialog-overview-park.component.scss']
})
export class OpendialogOverviewParkComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<OpendialogOverviewParkComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  ngOnInit(): void {
  }

}
